export default "__VITE_ASSET__BppUf5gP__"